import PropTypes from 'prop-types';
import React from 'react';
import Date from '../../date';
import Icon, { GLYPHS } from '../../icon';

const MonthSwitcher = ({ next, prev, month }) => (
  <div className="c-month-switcher u-mt">
    <button className="c-month-switcher__btn" type="button" onClick={prev}>
      <Icon glyph={GLYPHS.arrowLeft} />
    </button>
    <span className="c-month-switcher__content">
      <Date format="MMMM YYYY">{month}</Date>
    </span>
    <button className="c-month-switcher__btn" type="button" onClick={next}>
      <Icon glyph={GLYPHS.arrowRight} />
    </button>
  </div>
);

MonthSwitcher.propTypes = {
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  month: PropTypes.string.isRequired,
};

export default MonthSwitcher;
